import AurDrawerHeader from '../common/aur-drawer/AurDrawerHeader';
import AurDrawer from '../common/aur-drawer/AurDrawer';
import AurButton from '../common/aur-button/AurButton';
import AurDrawerPanelContainer from '../client-details/AurDrawerPanelContainer';
import {useEffect, useState} from 'react';
import {Box, FormControlLabel, Typography} from '@mui/material';
import {t} from 'i18next';
import {AurSwitch} from '../common/aur-switch/AurSwitch';
import {
  getAlertsList,
  updateAlertsList,
} from '../../api/ClientManagementService';
import AurPopup from '../common/aur-popup/AurPopup';
import AurAskLioDrawerHeaderButton from '../aur-ask-lio/AurAskLioDrawerHeaderButton';
import {AlertReuqest} from '../../types/client-management/cientManagementTypes';

type ClientAlertDrawerProps = {
  shouldShow: boolean;
  clientId: string;
  clientName: string;
  setclientAlertDrawerOpen: (value: boolean) => void;
  setManageItem: (value: string) => void;
};
interface Alert {
  clientAlertMasterId: string;
  alertCategory: string;
  alertName: string;
  alertDescription: string;
  alertCode: string;
  isEnabled: boolean;
}

const ClientAlertDrawer = (props: ClientAlertDrawerProps) => {
  const [cancelModal, setCancelModal] = useState<boolean>(false);
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const [initialAlerts, setInitialAlerts] = useState<Alert[]>([]);

  const fetchAlerts = async () => {
    try {
      const response = await getAlertsList(props?.clientId);
      setAlerts(response?.data?.data);
      setInitialAlerts(response?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (props.shouldShow) {
      fetchAlerts();
    }
  }, [props?.clientId, props.shouldShow]);

  const onSwitchToggled = (data: Alert) => {
    const modifiedAr = alerts.map((item: Alert) =>
      item.clientAlertMasterId === data?.clientAlertMasterId
        ? {...item, isEnabled: !data.isEnabled}
        : item
    );
    setAlerts(modifiedAr);
  };

  const saveBtnConditionCheck = (alts: Alert[], initial: Alert[]) => {
    return alts?.every(
      (ele: Alert) =>
        ele.isEnabled ===
        initial.find(
          (el: Alert) => el.clientAlertMasterId === ele.clientAlertMasterId
        )?.isEnabled
    );
  };

  const cancelBtnConditionCheck = (alts: Alert[], initial: Alert[]) => {
    const filtered = alts?.filter(
      (ele: Alert) =>
        ele.isEnabled !==
        initial.find(
          (el: Alert) => el.clientAlertMasterId === ele.clientAlertMasterId
        )?.isEnabled
    );
    return filtered?.length > 0;
  };

  const onSaveClick = async () => {
    const filtered = alerts?.filter(
      (ele: Alert) =>
        ele.isEnabled !==
        initialAlerts.find(
          (el: Alert) => el.clientAlertMasterId === ele.clientAlertMasterId
        )?.isEnabled
    );
    if (filtered?.length > 0) {
      try {
        const tempArr: AlertReuqest[] = [];
        filtered.forEach((ele: Alert) =>
          tempArr.push({alertCode: ele.alertCode, isEnabled: ele.isEnabled})
        );
        const res = await updateAlertsList(props?.clientId, tempArr);
        if (res.status === 200 && Array.isArray(res.data?.data)) {
          setAlerts(res.data.data);
          setInitialAlerts(res.data.data);
          cleanUpFunction();
        }
      } catch (err) {
        console.log(err);
      }
    }
  };
  const cleanUpFunction = () => {
    setCancelModal(false);
    props?.setclientAlertDrawerOpen(false);
    props?.setManageItem('');
    setAlerts([]);
    setInitialAlerts([]);
  };
  const onCloseClick = () => {
    if (cancelBtnConditionCheck(alerts, initialAlerts)) {
      setCancelModal(true);
    } else {
      cleanUpFunction();
    }
  };
  const onCancelClick = () => {
    if (cancelBtnConditionCheck(alerts, initialAlerts)) {
      setCancelModal(true);
    } else {
      cleanUpFunction();
    }
  };
  const closeModalHandler = () => {
    setCancelModal(false);
  };
  const confirmModalHandler = () => {
    cleanUpFunction();
  };
  const panelContainer = (
    <AurDrawerPanelContainer
      panelHeader={
        <Box className="client-alert-drawer-header">
          <AurButton
            classNames="drawer-close-button"
            label={t('label.close')}
            type="exit"
            size="Medium"
            title={t('label.close')}
            onClick={onCloseClick}
            ariaLabel={t('aria.closeUserPanelReturnClientDetails')}
            dataTestId='alert-drawer-close'
          />

          <AurAskLioDrawerHeaderButton />
        </Box>
      }
      contentHeader={
        <AurDrawerHeader
          title={t('title.manageAlertsInsights')}
          subtitle={t('title.alertDisabledInfo')}
          titleCssClass={'title-color'}
          buttons={[
            <div className="alert-update-buttons">
              <AurButton
                type={'exit'}
                label={t('buttons.cancel')}
                title={t('buttons.cancel')}
                // disabled={!isDirty}
                size="Medium"
                onClick={() => onCancelClick()}
                dataTestId="dontSaveButton-test"
                classNames="cancel-header-button"
              />

              <AurButton
                type={'continue'}
                label={t('buttons.save')}
                title={t('buttons.save')}
                disabled={saveBtnConditionCheck(alerts, initialAlerts)}
                size="Medium"
                buttonType="submit"
                dataTestId="saveButton-test"
                classNames="save-header-button"
                onClick={() => onSaveClick()}
              />
            </div>,
          ]}
        />
      }
      contentBody={
        <>
          <Typography className={'alerts-tab-divider'} tabIndex={0}>
            {t('clientDetailsPage.managedropDown.Alerts')}
          </Typography>

          <Box
            className="designation-section"
            sx={{height: '112px', width: '850px', rowGap: '48px'}}
          >
            <Box
              sx={{
                height: '56px',
                width: '850px',
                marginLeft: '48px',
                marginTop: '32px',
              }}
            >
              {alerts &&
                alerts?.map((alert) => (
                  <FormControlLabel
                    key={alert.clientAlertMasterId}
                    control={
                      <AurSwitch
                        dataTestId="is-active-switch"
                        checked={alert.isEnabled}
                        onChange={() => onSwitchToggled(alert)}
                      />
                    }
                    label={alert.alertName}
                    className="switch-button-div"
                  />
                ))}
            </Box>
          </Box>
        </>
      }
    />
  );

  return (
    <>
      <div
        className="client-drawer-container"
        data-testid="client-alerts-drawer"
      >
        <AurDrawer
          className="client-alert-drawer"
          open={props.shouldShow}
          onClose={() => props?.setclientAlertDrawerOpen(false)}
          anchor="right"
          drawerContent={panelContainer}
        />
        {cancelModal && (
          <AurPopup
            aria-label={t('aria.unsavedModal')}
            aria-description={t('aria.unsavedModalDescription')}
            className="inactivity-popup-modal"
            open={cancelModal}
            onOk={confirmModalHandler}
            onCancel={closeModalHandler}
            popupTitle={t(`common.cancelUploadPopup.title`)}
            popupHeading={t(`common.cancelUploadPopup.heading`)}
            showPopupHeading={true}
            showPopupTitle={true}
            showCloseIcon={false}
            popupContent={t(`common.cancelUploadPopup.content`)}
            labelActionCancel={t(`common.cancelUploadPopup.buttonStay`)}
            labelActionOk={t(`common.cancelUploadPopup.buttonYes`)}
          />
        )}
      </div>
    </>
  );
};

export default ClientAlertDrawer;
